import { render, staticRenderFns } from "./Correduria.vue?vue&type=template&id=1588f2b1"
import script from "./Correduria.vue?vue&type=script&lang=js"
export * from "./Correduria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1588f2b1')) {
      api.createRecord('1588f2b1', component.options)
    } else {
      api.reload('1588f2b1', component.options)
    }
    module.hot.accept("./Correduria.vue?vue&type=template&id=1588f2b1", function () {
      api.rerender('1588f2b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificaciones/Correduria.vue"
export default component.exports